module.exports = __WEBPACK_EXTERNAL_MODULE_91__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/net/URLRequest","root":["openfl","net","URLRequest"],"commonjs":"openfl/net/URLRequest","commonjs2":"openfl/net/URLRequest"}
// module id = 91
// module chunks = 0